import React, { useState } from "react";
import {
  Button,
  Offcanvas,
  Modal,
  OverlayTrigger,
  Tooltip,
  Table,
} from "react-bootstrap";
import Select from "react-select";
import useForm from "../../hooks/useForm";
import {
  AddOutlined,
  WallpaperOutlined,
  DeleteForeverOutlined,
  ModeEditOutlined,
} from "@mui/icons-material";

import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import useSectionClients from "../../hooks/useSectionClients";
import useProduct from "../../hooks/useProduct";
import { toast } from "react-hot-toast";
import axios from "axios";

const SidebarSectionClientsEdit = ({
  multimedia,
  institucional,
  otherInstitucional,
}) => {
  const { multimedias, editMultimedia } = useSectionClients();
  const { products } = useProduct();

  const productsOptions = products
    ?.filter((item) => item.deleted !== true)
    .map((item) => {
      return { label: item.title, value: item.title };
    });

  const user = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin?.name;
  const { values, setValues, handleInputChange } = useForm({
    deleted: false,
    name: multimedia?.name,
    filename: multimedia?.filename,
    imageMultimedia: multimedia?.imageMultimedia,
    _id: multimedia?._id,
  });
  const [showNewsSlide, setShowNewsSlide] = useState(false);
  const handleCloseSlide = () => setShowNewsSlide(false);
  const handleShowSlide = () => setShowNewsSlide(!showNewsSlide);

  const [modalFor, setModalFor] = useState(null);

  const handleSelectChange = (event) => {
    setValues({
      ...values,
      name: event.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const productsEdit = multimedias[0]?.products.map((edit) =>
      edit._id === multimedia?._id ? values : edit
    );
    const othersEdit = multimedias[0]?.others?.map((edit) =>
      edit._id === multimedia?._id ? values : edit
    );
    const objectProducts = {
      products: [...productsEdit],
      _id: multimedias[0]?._id,
      others: [...multimedias[0]?.others],
    };
    const objectOthers = {
      products: [...multimedias[0]?.products],
      _id: multimedias[0]?._id,
      others: [...othersEdit],
    };

    editMultimedia(institucional ? objectOthers : objectProducts);
  };

  // MODAL GALERIA
  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);

  const handleModalClick = (modalFor) => {
    setModalFor(modalFor);
    handleShowGaleria();
  };

  const handleFileProduct = async ({ target }) => {
    if (document.querySelector("#ficha-manual").value === "") {
      document.querySelector("#fileProduct").value = "";
      return toast.error("El archivo debe tener un nombre");
    }
    try {
      const form = new FormData();
      form.append("file", target.files[0]);
      form.append("_id", values._id);
      form.append("idMulti", multimedias[0]?._id);
      form.append("title", document.querySelector("#ficha-manual").value);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/multimedia/createDoc`,
        form,
        {
          headers: {
            authorization: JSON.parse(localStorage.getItem("Usuario")).token,
          },
        }
      );
      setValues({
        ...values,
        filename: [...values.filename, data.data],
      });
      document.querySelector("#ficha-manual").value = "";
      document.querySelector("#fileProduct").value = "";
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
      document.querySelector("#ficha-manual").value = "";
      document.querySelector("#fileProduct").value = "";
    }
  };
  
  return (
    <>
      <div className="pgi__sidebar-slides">
        <OverlayTrigger
          key="1"
          placement="top"
          overlay={<Tooltip id="1">Editar</Tooltip>}
        >
          <Button
            className="btn-form-pgi"
            variant="light"
            onClick={handleShowSlide}
          >
            <ModeEditOutlined />
          </Button>
        </OverlayTrigger>
        <Offcanvas
          show={showNewsSlide}
          onHide={handleCloseSlide}
          className="basePgi__pgi  pgi__sidebar-container"
          placement="end"
          scroll="true"
          enforceFocus
          backdrop={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {institucional
                ? "Multimedia Institucional"
                : "Multimedia para Productos"}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <form onSubmit={handleSubmit}>
              <button
                type="submit"
                className="settings_button-pleno news_button float-end"
              >
                GUARDAR
              </button>

              <div className="pgi__sidebar-container-items form-group w-100">
                {otherInstitucional === true ? (
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="name"
                      value={values.name}
                      onChange={handleInputChange}
                      placeholder={values.name}
                      required
                      maxLength={200}
                      minLength={2}
                    />
                    <label htmlFor="link2">Catégoria</label>
                  </div>
                ) : (
                  <div className="z-indexSelect mt-2">
                    <label htmlFor="name">Relacionado al producto:</label>
                    <Select
                      id="name"
                      options={[
                        { label: "Seleccione un producto", value: "" },
                        ...productsOptions,
                      ]}
                      className="form-selects"
                      name="name"
                      placeholder={
                        values?.name ? values.name : "Seleccione un producto"
                      }
                      onChange={(event) => handleSelectChange(event)}
                    />
                  </div>
                )}

                <Modal
                  id="galleryModal"
                  className="modalContenedor__galeria"
                  show={showGaleria}
                  onHide={handleCloseGaleria}
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <GaleriaPgiModal
                      editProduct={values}
                      setEditProduct={setValues}
                      modalFor={modalFor}
                      handleCloseGaleria={handleCloseGaleria}
                    />
                  </Modal.Body>
                </Modal>
                <div className="form-floating">
                  <Button
                    className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                    onClick={() => handleModalClick("imageMultimedia")}
                  >
                    Imagen Multimedia
                    <WallpaperOutlined />
                  </Button>
                  <p className="basePgi__comments">
                    <span>Imagen Multimedia (.jpg, .png)</span>
                  </p>
                </div>
                <hr className="basePgi__space-line" />
                <h3>Descargables</h3>
                <p className="basePgi__comments">
                  Adjunte los archivos de fichas o manuales técnicos
                </p>
                <div className="pgi__archivo">
                  <input
                    type="text"
                    className="form-control"
                    name="filename"
                    id="ficha-manual"
                    placeholder="Nombre de la etiqueta del archivo"
                    maxLength={90}
                    minLength={2}
                  />

                  <input
                    type="file"
                    className="form-control"
                    name="filename"
                    id="fileProduct"
                    placeholder="..."
                    onChange={handleFileProduct}
                  />
                </div>

                <Button variant="light" className="btn-form-pgi">
                  <AddOutlined />
                </Button>
                <Table responsive className="basePgi__table-list" hover>
                  <colgroup>
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="2" className="basePgi__table-col-min" />
                  </colgroup>
                  <tbody>
                    {values.filename?.map((file, index) => {
                      return (
                        !file.deleted && (
                          <>
                            <tr key={index}>
                              <td className="pgi__table-position-number">
                                <b>{file.title}</b>
                              </td>
                              <td>
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={
                                    <Tooltip id="1">Visibilidad</Tooltip>
                                  }
                                >
                                  <Button
                                    className={file.state ? "" : "disabled"}
                                    // onClick={() => handleFileVisibility(file.filename)}
                                  >
                                    {/* <VisibilityOutlined /> */}
                                  </Button>
                                </OverlayTrigger>
                              </td>
                              <td>
                                {" "}
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={<Tooltip id="1">Eliminar</Tooltip>}
                                >
                                  <Button>
                                    <DeleteForeverOutlined />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                              {/* <td><Button className={product.visible ? '' : 'disabled'} onClick={() => handleVisibility(product)}><VisibilityOutlined /></Button></td>
                                  {/* acción--> ELIMINA PUBLICACIÓN */}
                              {/*  <Button >
                        <DeleteForeverOutlined />
                      </Button> */}
                              {/* </td> */}
                            </tr>
                          </>
                        )
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </form>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default SidebarSectionClientsEdit;
